import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { types as api } from '@mesa-labs/mesa-api';

export type VendorDocumentsState = {
  documentType: api.VendorDocumentType | undefined;
  documentState: api.VendorDocumentState | undefined;
  missingDocumentContentsField: boolean;
  exportFormat: api.VendorDocumentExportFormat;
};

const initialState: VendorDocumentsState = {
  documentType: undefined,
  documentState: undefined,
  missingDocumentContentsField: false,
  exportFormat: api.VendorDocumentExportFormat.Standard
};

const vendorDocuments = createSlice({
  name: 'vendorDocuments',
  initialState,
  reducers: {
    updateDocumentType(state: VendorDocumentsState, action: PayloadAction<api.VendorDocumentType | undefined>) {
      state.documentType = action.payload;
    },
    updateDocumentState(state: VendorDocumentsState, action: PayloadAction<api.VendorDocumentState | undefined>) {
      state.documentState = action.payload;
    },
    updateMissingDocumentContentsField(state: VendorDocumentsState, action: PayloadAction<boolean>) {
      state.missingDocumentContentsField = action.payload;
    },
    updateExportFormat(state: VendorDocumentsState, action: PayloadAction<api.VendorDocumentExportFormat>) {
      state.exportFormat = action.payload;
    }
  },
});

export const {
  updateDocumentState,
  updateDocumentType,
  updateMissingDocumentContentsField,
  updateExportFormat
} = vendorDocuments.actions;
export default vendorDocuments.reducer;
